// import { Navigate, useLocation } from "react-router-dom";

// interface ProtectedRouteProps {
//     children: JSX.Element;
//     userToken: string | null;
// }

// const ProtectedRoute = ({ children, userToken }: ProtectedRouteProps) => {
//     const location = useLocation();

//     // ⏳ Enquanto o token ainda não foi decidido
//     if (userToken === undefined) {
//         return null; // ou um spinner
//     }

//     // 🔒 Não autenticado
//     if (!userToken) {
//         console.log(
//             "🔒 ProtectedRoute - Redirecionando para login, guardando rota:",
//             location.pathname
//         );

//         return (
//             <Navigate
//                 to="/login"
//                 replace
//                 state={{ from: location }}
//             />
//         );
//     }

//     // ✅ Autenticado
//     return children;
// };

// export default ProtectedRoute;


// import { Navigate, useLocation } from 'react-router-dom';
// import { ReactNode } from 'react';

// interface ProtectedRouteProps {
//     userToken: string | null | undefined;
//     children: ReactNode;
// }

// const ProtectedRoute = ({ userToken, children }: ProtectedRouteProps) => {
//     const location = useLocation();

//     // Se ainda está carregando (undefined), mostra loading
//     if (userToken === undefined) {
//         return (
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 height: '100vh'
//             }}>
//                 <div>Loading...</div>
//             </div>
//         );
//     }

//     // Se não tem token, redireciona para login COM O STATE
//     if (!userToken) {
//         console.log("⚠️ Usuário não autenticado, redirecionando para login");
//         console.log("📍 Localização atual que será salva:", location);

//         return <Navigate to="/login" state={{ from: location }} replace />;
//     }

//     // Se tem token, renderiza o children
//     return <>{children}</>;
// };

// export default ProtectedRoute;


import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth } from './contexts/AuthContext.tsx';

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { token, isLoading } = useAuth();
    const location = useLocation();

    console.log("🛡️ ProtectedRoute - Estado atual:");
    console.log("Token:", token);
    console.log("IsLoading:", isLoading);
    console.log("Pathname:", location.pathname);

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: '#0f172a'
            }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!token) {
        console.log("🔒 ProtectedRoute - Redirecionando para login com state");
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    console.log("✅ ProtectedRoute - Acesso permitido");
    return <>{children}</>;
};

export default ProtectedRoute;